export default {
    '5_MINUTES': 1000 * 60 * 5,
};
